$(document).ready(function() {
  $('#size_select_btn.add-to-cart').click(function() {   
    console.log("New",$(this));
    $(this).hide();
    $('.custom-Atc').show();
    $('.custom-variants-div').show();
  });
  
  $('.custom-variants-div.product-single__variants.no-js div').click(function(){
     $('.custom-variants-div.product-single__variants.no-js div').removeClass('Is-selected');
     $(this).addClass('Is-selected');
    
  });

  $('.Type-based-product-slider-main img').click(function(){
    $('.custom-Atc').hide();
    $('#size_select_btn.add-to-cart').show();
    $('.custom-variants-div').hide();
  });
  // var pol = $('.New-Custom-Link');
  // $('body').click(function(e) {
  //   if(e.target != pol ){
  //          $('.custom-Atc').hide();
  //   $('#size_select_btn.add-to-cart').show();
  //   $('.custom-variants-div').hide();
  //    console.log("clicked", e.target);
  //   }
  // });
  // window.addEventListener('mouseup',function(event){
  //       var pol = document.getElementById('New-Custom-Link');
  //       if(event.target != pol && event.target.parentNode != pol){
  //           console.log("clicked", pol);
  //       }
  // });  
 $('.custom-Atc.add-to-cart').click(function() {

    var var_id = $('.Is-selected').attr("variant-id");
    console.log("-",var_id);

      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: var_id
      },
        dataType: 'json', 
       success: function (data) { 

        console.log(data.quantity);
         var cart = new theme.CartDrawer;
          // cart.init()
          cart.open();
       
       } 
       });
      }); 
  
});

